import { findIndex, isEmpty, map } from "lodash/fp";

import type { RecommendationFilterType } from "@app/analytics/Recommendations/types";
import type { Recommendation } from "@app/analytics/types";
import { GroupedRecommendation } from "@app/analytics/types";
import * as RecommendationUtils from "@app/analytics/utils/recommendationUtils";

import { RECOMMENDATION_ACTION_FILTERS } from "./constants";

type FilterCountMap = { [key in RecommendationFilterType]: number };

export const getCountsByFilterType = (
  recommendations: Recommendation[]
): FilterCountMap => {
  return recommendations.reduce((countMap, rec) => {
    const defaultAction = RecommendationUtils.getDefaultAction(rec);
    const filter = RECOMMENDATION_ACTION_FILTERS.find(({ actionKinds }) =>
      actionKinds.includes(defaultAction.kind)
    );

    if (filter) {
      const currentCount = countMap[filter.id] ?? 0;
      return {
        ...countMap,
        [filter.id]: currentCount + 1,
      };
    }

    return countMap;
  }, {} as FilterCountMap);
};

export const getGroupedRecommendationIndexByRecommendationId = (
  recommendations: GroupedRecommendation[],
  id: string
) => {
  if (isEmpty(recommendations) || !id) return 0;

  const indexOfGroupedRecommendation = findIndex(
    (groupedRec) => map("id", groupedRec.recommendations).includes(id),
    recommendations
  );

  return Math.max(indexOfGroupedRecommendation, 0);
};

export const getGroupedRecommendationIndexById = (
  recommendations: GroupedRecommendation[],
  id: string
) => {
  if (isEmpty(recommendations) || !id) return 0;

  const indexOfGroupedRecommendation = findIndex({ id }, recommendations);
  return Math.max(indexOfGroupedRecommendation, 0);
};
